/**
 * Invoice Number Generation Utilities
 * Generiert fortlaufende Belegnummern im Format: PS{TT}{MM}{YY}{POSID}{LfdNr}
 */

import { settingsStorage } from '../services/storage';

/**
 * Generiert die nächste Belegnummer
 * Format: PS{TT}{MM}{YY}{POSID}{LfdNr}
 * - TT = Tag (2-stellig)
 * - MM = Monat (2-stellig)
 * - YY = Jahr (2-stellig)
 * - POSID = POS-ID aus Einstellungen (Default: "01")
 * - LfdNr = Laufende Nummer (5-stellig, mit führenden Nullen)
 * 
 * Die laufende Nummer wird pro Tag zurückgesetzt (bei Datumswechsel startet sie bei 1)
 */
export function generateNextInvoiceNumber(): string {
  const settings = settingsStorage.load();
  const posId = settings.pos_id || '01';
  
  // Aktuelles Datum
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = String(now.getFullYear()).slice(-2);
  const dateString = `${day}${month}${year}`;
  
  // Prüfe ob letzte Belegnummer vom heutigen Tag ist
  const lastInvoiceNumber = settings.last_invoice_number || 0;
  const lastInvoiceDate = settings.last_invoice_date || '';
  
  let nextNumber: number;
  
  if (lastInvoiceDate === dateString) {
    // Gleicher Tag: Nummer erhöhen
    nextNumber = lastInvoiceNumber + 1;
  } else {
    // Neuer Tag: Nummer bei 1 starten
    nextNumber = 1;
  }
  
  // Laufende Nummer mit führenden Nullen (5-stellig)
  const lfdNr = String(nextNumber).padStart(5, '0');
  
  // Belegnummer zusammenbauen
  const invoiceNumber = `PS${dateString}${posId}${lfdNr}`;
  
  // Aktualisiere letzte Nummer und Datum in Einstellungen
  settingsStorage.update({
    last_invoice_number: nextNumber,
    last_invoice_date: dateString
  });
  
  return invoiceNumber;
}

/**
 * Setzt die letzte Belegnummer (für manuelle Einstellung)
 */
export function setLastInvoiceNumber(number: number): void {
  settingsStorage.update({
    last_invoice_number: number
  });
}

/**
 * Gibt die aktuelle letzte Belegnummer zurück
 */
export function getLastInvoiceNumber(): number {
  const settings = settingsStorage.load();
  return settings.last_invoice_number || 0;
}

